import { useQuery, UseQueryOptions, UseQueryResult, QueryKey } from '@tanstack/react-query'

type NetworkMode = 'online' | 'always' | 'offlineFirst'

const DEFAULT_NETWORK_MODE: NetworkMode = 'online'

export const useAppQuery = <
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(
    options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryResult<TData, TError> =>
    useQuery({
        networkMode: DEFAULT_NETWORK_MODE,
        ...options,
    })
